import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminMedicationsPage } from './admin-medications';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminMedicationsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminMedicationsPage),
    DirectivesModule  
  ],
})
export class AdminMedicationsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-medications/admin-medications.module.ts